export default "data:text/javascript;base64,aW1wb3J0IE1hcFlhbmRleCBmcm9tICcuL01hcFlhbmRleC52dWUnCmV4cG9ydCB7IE1hcFlhbmRleCB9Cg=="